import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const recentSales = [{
  name: 'Valentina',
  city: 'Buenos Aires',
  time: 'hace 3 minutos'
}, {
  name: 'Camila',
  city: 'Córdoba',
  time: 'hace 8 minutos'
}, {
  name: 'Lucía',
  city: 'Rosario',
  time: 'hace 12 minutos'
}, {
  name: 'Martina',
  city: 'Mendoza',
  time: 'hace 18 minutos'
}, {
  name: 'Sofía',
  city: 'La Plata',
  time: 'hace 24 minutos'
}, {
  name: 'Florencia',
  city: 'Tucumán',
  time: 'hace 31 minutos'
}, {
  name: 'Agustina',
  city: 'Mar del Plata',
  time: 'hace 37 minutos'
}, {
  name: 'Julieta',
  city: 'Salta',
  time: 'hace 45 minutos'
}, {
  name: 'Carolina',
  city: 'Santa Fe',
  time: 'hace 52 minutos'
}, {
  name: 'Milagros',
  city: 'Neuquén',
  time: 'hace 1 hora'
}, {
  name: 'Rocío',
  city: 'Bahía Blanca',
  time: 'hace 1 hora'
}, {
  name: 'Daniela',
  city: 'San Juan',
  time: 'hace 2 horas'
}];
export function SalesNotifications() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNotification = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % recentSales.length);
    setVisible(true);
    setTimeout(() => setVisible(false), 4500);
  }, []);
  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(showNotification, 8000);
    // Then every 25 seconds
    const interval = setInterval(showNotification, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  const sale = recentSales[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-185">
      <AnimatePresence data-id="element-186">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -10
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 10,
        x: -10
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white/95 backdrop-blur-sm border border-sage/15 rounded-xl shadow-lg px-4 py-3 flex items-center gap-3" data-id="element-187">
            <div className="bg-sage-light/50 p-2 rounded-full flex-shrink-0" data-id="element-188">
              <ShoppingBag size={16} className="text-sage" data-id="element-189" />
            </div>
            <div className="min-w-0" data-id="element-190">
              <p className="text-sm text-warm-brown leading-snug" data-id="element-191">
                <span className="font-semibold" data-id="element-192">{sale.name}</span>
                <span className="text-warm-brown/70" data-id="element-193"> de {sale.city}</span>
              </p>
              <p className="text-xs text-sage" data-id="element-194">
                compró Calma Espiritual · {sale.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}